// Chain icons
import arbitrumChainIMG from '@/assets/imgs/chains/arbitrum.svg';
import baseChainIMG from '@/assets/imgs/chains/base.svg';
import bnbChainIMG from '@/assets/imgs/chains/bnb.svg';
import btcChainIMG from '@/assets/imgs/chains/btc.svg';
import ethereumChainIMG from '@/assets/imgs/chains/ethereum.svg';
import polygonChainIMG from '@/assets/imgs/chains/polygon.svg';
// Native token icons
import bnbTokenIMG from '@/assets/imgs/tokens/bnb.svg';
import btcTokenIMG from '@/assets/imgs/tokens/btc.svg';
import ethereumTokenIMG from '@/assets/imgs/tokens/ethereum.svg';
import polygonTokenIMG from '@/assets/imgs/tokens/polygon.svg';
import {
  arbitrum,
  base,
  bsc,
  bscTestnet,
  Chain,
  mainnet,
  polygon,
} from 'wagmi/chains';

export const CUSTOM_RPC_BY_CHAIN: Record<number, string> = {
  [bsc.id]: `https://bnb-mainnet.g.alchemy.com/v2/${import.meta.env.VITE_ALCHEMY_KEY}`,
  [bscTestnet.id]: `https://bnb-testnet.g.alchemy.com/v2/${import.meta.env.VITE_ALCHEMY_KEY}`,
  [mainnet.id]: `https://eth-mainnet.g.alchemy.com/v2/${import.meta.env.VITE_ALCHEMY_KEY}`,
  [arbitrum.id]: `https://arb-mainnet.g.alchemy.com/v2/${import.meta.env.VITE_ALCHEMY_KEY}`,
  [base.id]: `https://base-mainnet.g.alchemy.com/v2/${import.meta.env.VITE_ALCHEMY_KEY}`,
  [polygon.id]: `https://polygon-mainnet.g.alchemy.com/v2/${import.meta.env.VITE_ALCHEMY_KEY}`,
  [0]: `https://bitcoin-mainnet.g.alchemy.com/v2/${import.meta.env.VITE_ALCHEMY_KEY}`,
};

export const bitcoinChain: Chain = {
  id: 0,
  name: 'Bitcoin',
  nativeCurrency: {
    symbol: 'BTC',
    decimals: 8,
    name: 'Bitcoin',
  },
  rpcUrls: {
    default: {
      http: CUSTOM_RPC_BY_CHAIN[0] as unknown as readonly string[],
    },
  },
};

export const CHAIN_SHORT_NAME: Record<number, string> = {
  [bsc.id]: 'bnb',
  [bscTestnet.id]: 'bnb',
  [mainnet.id]: 'eth',
  [arbitrum.id]: 'arb',
  [base.id]: 'base',
  [polygon.id]: 'pol',
  [bitcoinChain.id]: 'btc',
};

export type SupportedChainConfig = {
  chain: Chain;
  label: string;
  icon: string;
  nativeIcon: string;
};

export const SUPPORTED_CHAINS: Record<number, SupportedChainConfig> = {
  [bsc.id]: {
    chain: bsc,
    label: 'Binance',
    icon: bnbChainIMG,
    nativeIcon: bnbTokenIMG,
  },
  [mainnet.id]: {
    chain: mainnet,
    label: 'Ethereum',
    icon: ethereumChainIMG,
    nativeIcon: ethereumTokenIMG,
  },
  [arbitrum.id]: {
    chain: arbitrum,
    label: 'Arbitrum',
    icon: arbitrumChainIMG,
    nativeIcon: ethereumTokenIMG,
  },
  [base.id]: {
    chain: base,
    label: 'Base',
    icon: baseChainIMG,
    nativeIcon: ethereumTokenIMG,
  },
  [polygon.id]: {
    chain: polygon,
    label: 'Polygon',
    icon: polygonChainIMG,
    nativeIcon: polygonTokenIMG,
  },
  [bitcoinChain.id]: {
    chain: bitcoinChain,
    label: 'Bitcoin',
    icon: btcChainIMG,
    nativeIcon: btcTokenIMG,
  },
};

export const DEFAULT_CHAIN = bsc;

export enum SUPPORTED_CHAIN_IDS {
  BSC = bsc.id,
  ETH = mainnet.id,
  BASE = base.id,
  POLYGON = polygon.id,
  ARBITRUM = arbitrum.id,
  BTC = bitcoinChain.id,
}
